import { createFileRoute } from "@tanstack/react-router";
import { validateQuoteSearch } from "@/lib/quote-search";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";

export const Route = createFileRoute("/get-a-quote")({
  validateSearch: validateQuoteSearch,
  head: () => buildHead({
    locale: "en",
    title: "Request a Shopify Scope · Shugert",
    description: "Share the Shopify constraint, confirm the closest entry project and receive a focused next step from Shugert.",
    path: "/get-a-quote",
    altPath: alternatePath("/get-a-quote", "es"),
    noindex: true,
    jsonLd: breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Request a scope", path: "/get-a-quote" }]),
  }),
});